/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/forms';
import * as i2 from 'angular2-recaptcha/lib/captcha.component';
import * as i3 from 'angular2-recaptcha/lib/captcha.service';
const styles_ReCaptchaComponent:any[] = ([] as any[]);
export const RenderType_ReCaptchaComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_ReCaptchaComponent,data:{}});
export function View_ReCaptchaComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵqud(402653184,1,{targetRef:0}),(_l()(),i0.ɵeld(1,0,[[1,0],
      ['target',1]],(null as any),0,'div',([] as any[]),(null as any),(null as any),
      (null as any),(null as any),(null as any)))],(null as any),(null as any));
}
export function View_ReCaptchaComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),2,'re-captcha',
      ([] as any[]),(null as any),(null as any),(null as any),View_ReCaptchaComponent_0,
      RenderType_ReCaptchaComponent)),i0.ɵprd(5120,(null as any),i1.NG_VALUE_ACCESSOR,
      (p0_0:any) => {
        return [p0_0];
      },[i2.ReCaptchaComponent]),i0.ɵdid(2,114688,(null as any),0,i2.ReCaptchaComponent,
      [i0.NgZone,i3.ReCaptchaService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,2,0);
  },(null as any));
}
export const ReCaptchaComponentNgFactory:i0.ComponentFactory<i2.ReCaptchaComponent> = i0.ɵccf('re-captcha',
    i2.ReCaptchaComponent,View_ReCaptchaComponent_Host_0,{site_key:'site_key',theme:'theme',
        type:'type',size:'size',tabindex:'tabindex',badge:'badge',language:'language'},
    {captchaResponse:'captchaResponse',captchaExpired:'captchaExpired'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvQXN5bHVtL2lkZW50aXR5LXZhZ3JhbnQvc3JjL2FzeWx1bS1pZGVuZXRpdHkvbm9kZV9tb2R1bGVzL2FuZ3VsYXIyLXJlY2FwdGNoYS9saWIvY2FwdGNoYS5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vQzovVXNlcnMvQXN5bHVtL2lkZW50aXR5LXZhZ3JhbnQvc3JjL2FzeWx1bS1pZGVuZXRpdHkvbm9kZV9tb2R1bGVzL2FuZ3VsYXIyLXJlY2FwdGNoYS9saWIvY2FwdGNoYS5jb21wb25lbnQuZC50cyIsIm5nOi8vL0M6L1VzZXJzL0FzeWx1bS9pZGVudGl0eS12YWdyYW50L3NyYy9hc3lsdW0taWRlbmV0aXR5L25vZGVfbW9kdWxlcy9hbmd1bGFyMi1yZWNhcHRjaGEvbGliL2NhcHRjaGEuY29tcG9uZW50LmQudHMuUmVDYXB0Y2hhQ29tcG9uZW50Lmh0bWwiLCJuZzovLy9DOi9Vc2Vycy9Bc3lsdW0vaWRlbnRpdHktdmFncmFudC9zcmMvYXN5bHVtLWlkZW5ldGl0eS9ub2RlX21vZHVsZXMvYW5ndWxhcjItcmVjYXB0Y2hhL2xpYi9jYXB0Y2hhLmNvbXBvbmVudC5kLnRzLlJlQ2FwdGNoYUNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgI3RhcmdldD48L2Rpdj4iLCI8cmUtY2FwdGNoYT48L3JlLWNhcHRjaGE+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozt1RENBQTtNQUFBO01BQUE7OztvQkNBQTtNQUFBO21DQUFBO01BQUE7UUFBQTtNQUFBLGtDQUFBO01BQUE7SUFBQTs7Ozs7OyJ9



// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/aot/node_modules/angular2-recaptcha/lib/captcha.component.ngfactory.ts